(function () {
  'use strict';

  if (window.__FH_EVENTS_CART_INSTALLED__) return;
  window.__FH_EVENTS_CART_INSTALLED__ = true;

  var DEFAULT_I18N = {
    hold_label: 'Platz reserviert für',
    hold_expired: 'Reservierung abgelaufen',
    hold_verifying: 'Reservierung wird beim Checkout geprüft',
    checkout_active: 'Weiter zur Kasse — noch {{time}}',
    checkout_blocked: 'Ticket prüfen, um fortzufahren',
    remove_pending: 'Ticket wird entfernt…',
    recovery_error: 'Das Ticket konnte nicht entfernt werden. Bitte versuche es erneut.'
  };
  var observer = null;
  var timer = null;

  function safeText(value, fallback) {
    return typeof value === 'string' && value ? value : (fallback || '');
  }

  function safeSlug(value) {
    var slug = safeText(value, '').toLowerCase();
    return /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(slug) ? slug : '';
  }

  function trackAnalytics(name, context) {
    var analytics = window.FunnyHooksEventsAnalytics;
    if (!analytics || typeof analytics.track !== 'function') return null;
    return analytics.track(name, context);
  }

  function readI18n() {
    var out = Object.assign({}, DEFAULT_I18N);
    var script = document.querySelector('[data-fh-event-cart-i18n]');
    if (!script) return out;
    try {
      var parsed = JSON.parse(script.textContent || '{}');
      Object.keys(out).forEach(function (key) {
        if (parsed && typeof parsed[key] === 'string' && parsed[key]) out[key] = parsed[key];
      });
    } catch (error) {}
    return out;
  }

  function interpolate(template, values) {
    return safeText(template, '').replace(/\{\{\s*([a-z0-9_]+)\s*\}\}/gi, function (_, key) {
      return Object.prototype.hasOwnProperty.call(values || {}, key) ? String(values[key]) : '';
    });
  }

  function setText(element, value) {
    if (element && element.textContent !== value) element.textContent = value;
  }

  function remainingParts(expiresAt) {
    var expiry = Date.parse(safeText(expiresAt, ''));
    if (!Number.isFinite(expiry)) return null;
    var seconds = Math.max(0, Math.ceil((expiry - Date.now()) / 1000));
    var minutes = Math.floor(seconds / 60);
    var remainder = seconds % 60;
    return {
      expired: seconds <= 0,
      seconds: seconds,
      minuteBucket: Math.ceil(seconds / 60),
      display: String(minutes) + ':' + String(remainder).padStart(2, '0')
    };
  }

  function formatEventDate(line) {
    var time = line.querySelector('[data-fh-event-cart-date-time]');
    if (!time) return;
    var start = Date.parse(safeText(time.getAttribute('datetime'), ''));
    if (!Number.isFinite(start)) return;
    var end = Date.parse(safeText(time.getAttribute('data-end-at'), ''));
    var locale = document.documentElement.lang || 'de-AT';
    try {
      var date = new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(start));
      if (Number.isFinite(end)) {
        date += '–' + new Intl.DateTimeFormat(locale, { timeStyle: 'short' }).format(new Date(end));
      }
      setText(time, date);
    } catch (error) {}
  }

  function eventUrlForLine(line) {
    var slug = safeSlug(line && line.getAttribute('data-fh-event-slug'));
    return slug ? '/pages/veranstaltungen?event=' + encodeURIComponent(slug) + '#event-' + slug : '';
  }

  function setLiveStatus(line, message, key) {
    var status = line.querySelector('[data-fh-event-cart-status]');
    if (!status || status.getAttribute('data-last-status-key') === key) return;
    status.setAttribute('data-last-status-key', key);
    setText(status, message);
  }

  function showRecovery(line, action, i18n) {
    var recovery = line.querySelector('[data-fh-event-cart-recovery]');
    if (!recovery) return;
    recovery.hidden = false;
    line.setAttribute('data-fh-event-cart-state', 'recovery');
    var remove = recovery.querySelector('[data-fh-event-cart-remove-retry]');
    var returnLink = recovery.querySelector('[data-fh-event-cart-return]');
    if (remove) remove.hidden = action !== 'remove_and_retry';
    if (returnLink) {
      returnLink.hidden = action === 'remove_and_retry';
      var eventUrl = eventUrlForLine(line);
      if (eventUrl) returnLink.href = eventUrl;
    }
    setLiveStatus(
      line,
      action === 'remove_and_retry' ? i18n.hold_expired : i18n.checkout_blocked,
      'recovery:' + action
    );
  }

  function renderLine(line, i18n) {
    formatEventDate(line);
    var forcedAction = safeText(line.getAttribute('data-fh-event-recovery-action'), '');
    if (forcedAction) {
      showRecovery(line, forcedAction, i18n);
      return { state: 'recovery', remaining: null };
    }

    var countdown = line.querySelector('[data-fh-event-cart-countdown]');
    var recovery = line.querySelector('[data-fh-event-cart-recovery]');
    var parts = remainingParts(line.getAttribute('data-fh-event-expires-at'));
    if (!parts) {
      line.setAttribute('data-fh-event-cart-state', 'unknown');
      if (recovery) recovery.hidden = true;
      setText(countdown, i18n.hold_verifying);
      return { state: 'unknown', remaining: null };
    }

    if (parts.expired) {
      setText(countdown, i18n.hold_expired);
      showRecovery(line, 'remove_and_retry', i18n);
      line.setAttribute('data-fh-event-cart-state', 'expired');
      return { state: 'expired', remaining: 0 };
    }

    line.setAttribute('data-fh-event-cart-state', 'active');
    if (recovery) recovery.hidden = true;
    setText(countdown, parts.display);
    setLiveStatus(line, i18n.hold_label + ' ' + parts.display, 'minute:' + parts.minuteBucket);
    return { state: 'active', remaining: parts.seconds };
  }

  function linesForCheckout(button) {
    if (button.id === 'CartDrawer-Checkout') {
      var drawer = button.closest('cart-drawer') || document.querySelector('cart-drawer');
      return drawer ? Array.from(drawer.querySelectorAll('[data-fh-event-cart-line]')) : [];
    }
    var main = document.querySelector('#main-cart-items');
    return main ? Array.from(main.querySelectorAll('[data-fh-event-cart-line]')) : [];
  }

  function setManagedDisabled(button, disabled) {
    if (disabled) {
      if (!button.disabled) button.setAttribute('data-fh-event-cart-managed-disabled', 'true');
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      return;
    }
    if (button.getAttribute('data-fh-event-cart-managed-disabled') === 'true') {
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      button.removeAttribute('data-fh-event-cart-managed-disabled');
    }
  }

  function updateCheckoutButtons(i18n) {
    document.querySelectorAll('[data-fh-event-checkout]').forEach(function (button) {
      if (!button.hasAttribute('data-fh-event-checkout-default')) {
        button.setAttribute('data-fh-event-checkout-default', button.textContent.trim());
      }
      var lines = linesForCheckout(button);
      if (!lines.length) {
        setManagedDisabled(button, false);
        setText(button, button.getAttribute('data-fh-event-checkout-default'));
        return;
      }
      var states = lines.map(function (line) {
        return {
          state: line.getAttribute('data-fh-event-cart-state'),
          parts: remainingParts(line.getAttribute('data-fh-event-expires-at'))
        };
      });
      var blocked = states.some(function (entry) {
        return entry.state === 'expired' || entry.state === 'recovery';
      });
      if (blocked) {
        setManagedDisabled(button, true);
        setText(button, i18n.checkout_blocked);
        return;
      }
      setManagedDisabled(button, false);
      var active = states
        .map(function (entry) { return entry.parts && !entry.parts.expired ? entry.parts.seconds : null; })
        .filter(function (seconds) { return Number.isFinite(seconds); });
      if (active.length) {
        var shortest = Math.min.apply(Math, active);
        var minutes = Math.floor(shortest / 60);
        var seconds = shortest % 60;
        setText(button, interpolate(i18n.checkout_active, {
          time: String(minutes) + ':' + String(seconds).padStart(2, '0')
        }));
      }
    });

    var hasEventLines = !!document.querySelector('[data-fh-event-cart-line]');
    document.querySelectorAll('.additional-checkout-buttons').forEach(function (container) {
      if (hasEventLines) {
        container.hidden = true;
        container.setAttribute('data-fh-event-cart-hidden', 'true');
      } else if (container.getAttribute('data-fh-event-cart-hidden') === 'true') {
        container.hidden = false;
        container.removeAttribute('data-fh-event-cart-hidden');
      }
    });
  }

  function refresh() {
    if (observer) observer.disconnect();
    if (timer) {
      window.clearTimeout(timer);
      timer = null;
    }
    var i18n = readI18n();
    var needsTick = false;
    document.querySelectorAll('[data-fh-event-cart-line]').forEach(function (line) {
      if (renderLine(line, i18n).state === 'active') needsTick = true;
    });
    updateCheckoutButtons(i18n);
    if (observer) observer.observe(document.body, { childList: true, subtree: true });
    if (needsTick) timer = window.setTimeout(refresh, 1000);
  }

  function waitForRelease(slug) {
    return new Promise(function (resolve) {
      var timeout = window.setTimeout(done, 1800);
      function done() {
        window.clearTimeout(timeout);
        document.removeEventListener('fh:events:cart-line-released', onReleased);
        resolve();
      }
      function onReleased(event) {
        if (safeSlug(event && event.detail && event.detail.slug) === slug) done();
      }
      document.addEventListener('fh:events:cart-line-released', onReleased);
    });
  }

  function removeExpiredLine(line, button) {
    var slug = safeSlug(line.getAttribute('data-fh-event-slug'));
    var lineKey = safeText(line.getAttribute('data-fh-event-line-key'), '');
    var eventUrl = eventUrlForLine(line);
    var i18n = readI18n();
    if (!slug || !lineKey || lineKey.length > 256 || /[\u0000-\u001f\u007f]/.test(lineKey)) return;

    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    line.setAttribute('aria-busy', 'true');
    setText(button, i18n.remove_pending);
    var releaseObserved = waitForRelease(slug);

    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    }).then(function (response) {
      if (!response || !response.ok) throw new Error('event_cart_remove_failed');
      return releaseObserved;
    }).then(function () {
      document.dispatchEvent(new CustomEvent('fh:events:cart-recovery-complete', { detail: { slug: slug } }));
      if (eventUrl) window.location.assign(eventUrl);
    }).catch(function () {
      line.setAttribute('aria-busy', 'false');
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      setText(button, button.getAttribute('data-label') || '');
      setLiveStatus(line, i18n.recovery_error, 'remove-error');
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest
      ? event.target.closest('[data-fh-event-cart-remove-retry], [data-fh-event-cart-return]')
      : null;
    if (!button) return;
    var line = button.closest('[data-fh-event-cart-line]');
    if (!line) return;
    trackAnalytics('booking_recovery_clicked', {
      event_slug: safeSlug(line.getAttribute('data-fh-event-slug')),
      surface: line.closest && line.closest('cart-drawer') ? 'cart_drawer' : 'cart',
      booking_mode: 'shopify_checkout',
      action: button.hasAttribute('data-fh-event-cart-remove-retry') ? 'remove_and_retry' : 'return_to_event'
    });
    if (!button.hasAttribute('data-fh-event-cart-remove-retry')) return;
    event.preventDefault();
    removeExpiredLine(line, button);
  });

  document.addEventListener('fh:events:cart-recovery-required', function (event) {
    var slug = safeSlug(event && event.detail && event.detail.slug);
    var action = safeText(event && event.detail && event.detail.action, 'return_to_event');
    if (!slug || (action !== 'remove_and_retry' && action !== 'return_to_event')) return;
    document.querySelectorAll('[data-fh-event-cart-line]').forEach(function (line) {
      if (safeSlug(line.getAttribute('data-fh-event-slug')) !== slug) return;
      line.setAttribute('data-fh-event-recovery-action', action);
    });
    refresh();
  });

  function init() {
    observer = new MutationObserver(refresh);
    observer.observe(document.body, { childList: true, subtree: true });
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
